module.exports = "<flash-messages></flash-messages>\n<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/layout/layouts/nomenu.template.html
// module id = ../../../../../src/app/layout/layouts/nomenu.template.html
// module chunks = 3